import styles from './TestMockGlobalTopNav.module.css';

function TestMockGlobalTopNav() {
  return (
    <nav id="GlobalNavigation" className={styles.nav}>
      <center>TestMockGlobalTopNav</center>
    </nav>
  );
}

export default TestMockGlobalTopNav;
